import { createI18n, DefaultDateTimeFormatSchema, DefaultNumberFormatSchema } from 'vue-i18n';

// Import des traductions locales — FR
import frAdmin from './locales/fr/admin.json';
import frAuth from './locales/fr/auth.json';
import frBusiness from './locales/fr/business.json';
import frCommon from './locales/fr/common.json';
import frDocuments from './locales/fr/documents.json';
import frForms from './locales/fr/forms.json';
import frLegal from './locales/fr/legal.json';
import frOrder from './locales/fr/order.json';
import frReleaseNote from './locales/fr/release-note.json';
import frUser from './locales/fr/user.json';
// Import des traductions locales — EN
import enAdmin from './locales/en/admin.json';
import enAuth from './locales/en/auth.json';
import enBusiness from './locales/en/business.json';
import enCommon from './locales/en/common.json';
import enDocuments from './locales/en/documents.json';
import enForms from './locales/en/forms.json';
import enLegal from './locales/en/legal.json';
import enOrder from './locales/en/order.json';
import enReleaseNote from './locales/en/release-note.json';
import enUser from './locales/en/user.json';
// Import des traductions locales — DE
import deAdmin from './locales/de/admin.json';
import deAuth from './locales/de/auth.json';
import deBusiness from './locales/de/business.json';
import deCommon from './locales/de/common.json';
import deDocuments from './locales/de/documents.json';
import deForms from './locales/de/forms.json';
import deLegal from './locales/de/legal.json';
import deOrder from './locales/de/order.json';
import deReleaseNote from './locales/de/release-note.json';
import deUser from './locales/de/user.json';
// Import des traductions locales — NL
import nlAdmin from './locales/nl/admin.json';
import nlAuth from './locales/nl/auth.json';
import nlBusiness from './locales/nl/business.json';
import nlCommon from './locales/nl/common.json';
import nlDocuments from './locales/nl/documents.json';
import nlForms from './locales/nl/forms.json';
import nlLegal from './locales/nl/legal.json';
import nlOrder from './locales/nl/order.json';
import nlReleaseNote from './locales/nl/release-note.json';
import nlUser from './locales/nl/user.json';
// Import des traductions locales — ES
import esAdmin from './locales/es/admin.json';
import esAuth from './locales/es/auth.json';
import esBusiness from './locales/es/business.json';
import esCommon from './locales/es/common.json';
import esDocuments from './locales/es/documents.json';
import esForms from './locales/es/forms.json';
import esLegal from './locales/es/legal.json';
import esOrder from './locales/es/order.json';
import esReleaseNote from './locales/es/release-note.json';
import esUser from './locales/es/user.json';
// Import des traductions locales — HU
import huAdmin from './locales/hu/admin.json';
import huAuth from './locales/hu/auth.json';
import huBusiness from './locales/hu/business.json';
import huCommon from './locales/hu/common.json';
import huDocuments from './locales/hu/documents.json';
import huForms from './locales/hu/forms.json';
import huLegal from './locales/hu/legal.json';
import huOrder from './locales/hu/order.json';
import huReleaseNote from './locales/hu/release-note.json';
import huUser from './locales/hu/user.json';
// Import des traductions locales — IT
import itAdmin from './locales/it/admin.json';
import itAuth from './locales/it/auth.json';
import itBusiness from './locales/it/business.json';
import itCommon from './locales/it/common.json';
import itDocuments from './locales/it/documents.json';
import itForms from './locales/it/forms.json';
import itLegal from './locales/it/legal.json';
import itOrder from './locales/it/order.json';
import itReleaseNote from './locales/it/release-note.json';
import itUser from './locales/it/user.json';
// Import des traductions locales — PL
import plAdmin from './locales/pl/admin.json';
import plAuth from './locales/pl/auth.json';
import plBusiness from './locales/pl/business.json';
import plCommon from './locales/pl/common.json';
import plDocuments from './locales/pl/documents.json';
import plForms from './locales/pl/forms.json';
import plLegal from './locales/pl/legal.json';
import plOrder from './locales/pl/order.json';
import plReleaseNote from './locales/pl/release-note.json';
import plUser from './locales/pl/user.json';
// Import des traductions locales — PT
import ptAdmin from './locales/pt/admin.json';
import ptAuth from './locales/pt/auth.json';
import ptBusiness from './locales/pt/business.json';
import ptCommon from './locales/pt/common.json';
import ptDocuments from './locales/pt/documents.json';
import ptForms from './locales/pt/forms.json';
import ptLegal from './locales/pt/legal.json';
import ptOrder from './locales/pt/order.json';
import ptReleaseNote from './locales/pt/release-note.json';
import ptUser from './locales/pt/user.json';
// Import des traductions locales — RO
import roAdmin from './locales/ro/admin.json';
import roAuth from './locales/ro/auth.json';
import roBusiness from './locales/ro/business.json';
import roCommon from './locales/ro/common.json';
import roDocuments from './locales/ro/documents.json';
import roForms from './locales/ro/forms.json';
import roLegal from './locales/ro/legal.json';
import roOrder from './locales/ro/order.json';
import roReleaseNote from './locales/ro/release-note.json';
import roUser from './locales/ro/user.json';
// Import des traductions locales — TR
import trAdmin from './locales/tr/admin.json';
import trAuth from './locales/tr/auth.json';
import trBusiness from './locales/tr/business.json';
import trCommon from './locales/tr/common.json';
import trDocuments from './locales/tr/documents.json';
import trForms from './locales/tr/forms.json';
import trLegal from './locales/tr/legal.json';
import trOrder from './locales/tr/order.json';
import trReleaseNote from './locales/tr/release-note.json';
import trUser from './locales/tr/user.json';
// Import des traductions locales — UK
import ukAdmin from './locales/uk/admin.json';
import ukAuth from './locales/uk/auth.json';
import ukBusiness from './locales/uk/business.json';
import ukCommon from './locales/uk/common.json';
import ukDocuments from './locales/uk/documents.json';
import ukForms from './locales/uk/forms.json';
import ukLegal from './locales/uk/legal.json';
import ukOrder from './locales/uk/order.json';
import ukReleaseNote from './locales/uk/release-note.json';
import ukUser from './locales/uk/user.json';

// Liste des langues supportées (12 langues)
export const supportedLocales: SupportedLocale[] = ['fr', 'en', 'de', 'nl', 'es', 'hu', 'it', 'pl', 'pt', 'ro', 'tr', 'uk'];

export const localeLabels: Record<SupportedLocale, { label: string, flag: string }> = {
	fr: { label: 'Français', flag: '🇫🇷' },
	en: { label: 'English', flag: '🇬🇧' },
	de: { label: 'Deutsch', flag: '🇩🇪' },
	nl: { label: 'Nederlands', flag: '🇳🇱' },
	es: { label: 'Español', flag: '🇪🇸' },
	hu: { label: 'Magyar', flag: '🇭🇺' },
	it: { label: 'Italiano', flag: '🇮🇹' },
	pl: { label: 'Polski', flag: '🇵🇱' },
	pt: { label: 'Português', flag: '🇵🇹' },
	ro: { label: 'Română', flag: '🇷🇴' },
	tr: { label: 'Türkçe', flag: '🇹🇷' },
	uk: { label: 'Українська', flag: '🇺🇦' },
};

// Messages par langue
const messages = {
	fr: { ...frCommon, ...frAdmin, ...frAuth, ...frBusiness, ...frDocuments, ...frForms, ...frLegal, ...frOrder, ...frReleaseNote, ...frUser },
	en: { ...enCommon, ...enAdmin, ...enAuth, ...enBusiness, ...enDocuments, ...enForms, ...enLegal, ...enOrder, ...enReleaseNote, ...enUser },
	de: { ...deCommon, ...deAdmin, ...deAuth, ...deBusiness, ...deDocuments, ...deForms, ...deLegal, ...deOrder, ...deReleaseNote, ...deUser },
	nl: { ...nlCommon, ...nlAdmin, ...nlAuth, ...nlBusiness, ...nlDocuments, ...nlForms, ...nlLegal, ...nlOrder, ...nlReleaseNote, ...nlUser },
	es: { ...esCommon, ...esAdmin, ...esAuth, ...esBusiness, ...esDocuments, ...esForms, ...esLegal, ...esOrder, ...esReleaseNote, ...esUser },
	hu: { ...huCommon, ...huAdmin, ...huAuth, ...huBusiness, ...huDocuments, ...huForms, ...huLegal, ...huOrder, ...huReleaseNote, ...huUser },
	it: { ...itCommon, ...itAdmin, ...itAuth, ...itBusiness, ...itDocuments, ...itForms, ...itLegal, ...itOrder, ...itReleaseNote, ...itUser },
	pl: { ...plCommon, ...plAdmin, ...plAuth, ...plBusiness, ...plDocuments, ...plForms, ...plLegal, ...plOrder, ...plReleaseNote, ...plUser },
	pt: { ...ptCommon, ...ptAdmin, ...ptAuth, ...ptBusiness, ...ptDocuments, ...ptForms, ...ptLegal, ...ptOrder, ...ptReleaseNote, ...ptUser },
	ro: { ...roCommon, ...roAdmin, ...roAuth, ...roBusiness, ...roDocuments, ...roForms, ...roLegal, ...roOrder, ...roReleaseNote, ...roUser },
	tr: { ...trCommon, ...trAdmin, ...trAuth, ...trBusiness, ...trDocuments, ...trForms, ...trLegal, ...trOrder, ...trReleaseNote, ...trUser },
	uk: { ...ukCommon, ...ukAdmin, ...ukAuth, ...ukBusiness, ...ukDocuments, ...ukForms, ...ukLegal, ...ukOrder, ...ukReleaseNote, ...ukUser },
};

// Formats de date par locale
const defaultDatetimeFormats: DefaultDateTimeFormatSchema = {
	short: { year: 'numeric', month: 'short', day: 'numeric' },
	long: { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' },
	time: { hour: '2-digit', minute: '2-digit' },
};
const datetimeFormats = {
	fr: defaultDatetimeFormats,
	en: defaultDatetimeFormats,
	de: defaultDatetimeFormats,
	nl: defaultDatetimeFormats,
	es: defaultDatetimeFormats,
	hu: defaultDatetimeFormats,
	it: defaultDatetimeFormats,
	pl: defaultDatetimeFormats,
	pt: defaultDatetimeFormats,
	ro: defaultDatetimeFormats,
	tr: defaultDatetimeFormats,
	uk: defaultDatetimeFormats,
};

// Formats de nombre par locale
const defaultNumberFormat: DefaultNumberFormatSchema = {
	currency: { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 },
	decimal: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
	percent: { style: 'percent', minimumFractionDigits: 1 },
};
const numberFormats = {
	fr: defaultNumberFormat,
	en: defaultNumberFormat,
	de: defaultNumberFormat,
	nl: defaultNumberFormat,
	es: defaultNumberFormat,
	hu: defaultNumberFormat,
	it: defaultNumberFormat,
	pl: defaultNumberFormat,
	pt: defaultNumberFormat,
	ro: defaultNumberFormat,
	tr: defaultNumberFormat,
	uk: defaultNumberFormat,
};

export const i18n = createI18n({
	legacy: false, // Composition API
	locale: 'fr',
	fallbackLocale: 'fr',
	missingWarn: false, // Désactivé car le monkey-patch gère le fallback namespace
	fallbackWarn: false, // Évite les warnings de fallback pour les clés avec namespace
	messages,
	datetimeFormats,
	numberFormats,
});

// Monkey-patch i18n.global.t() pour supporter les clés avec namespace (flattener)
// Sans ce patch, i18n.global.t('common.loadingYourAccount') cherche la clé exacte
// "common.loadingYourAccount" qui n'existe pas (la clé dans le JSON est "loadingYourAccount").
// Le patch essaie d'abord la clé originale, puis retire le premier segment (namespace).
type TranslateArgs = unknown[];

const originalT = i18n.global.t.bind(i18n.global) as (key: string, ...args: TranslateArgs) => string;
(i18n.global as any).t = (key: string, ...args: TranslateArgs): string => {
	const result = originalT(key, ...args) as string;
	if (result === key) {
		const dotIndex = key.indexOf('.');
		if (dotIndex > 0) {
			const flatKey = key.substring(dotIndex + 1);
			const flatResult = originalT(flatKey, ...args) as string;
			if (flatResult !== flatKey) return flatResult;
		}
	}
	return result;
};

// Helper pour changer de langue
export function setLocale (locale: SupportedLocale, reload = false) {
	i18n.global.locale.value = locale;
	document.documentElement.lang = locale;
	localStorage.setItem('locale', locale);
	// Recharger la page pour que les labels de navigation (non-réactifs) soient recalculés
	if (reload) {
		window.location.reload();
	}
}

// Récupérer la langue sauvegardée
export function getSavedLocale (): SupportedLocale {
	const saved = localStorage.getItem('locale');
	if (saved && supportedLocales.includes(saved as SupportedLocale)) {
		return saved as SupportedLocale;
	}
	// Détection automatique de la langue du navigateur
	const browserLang = navigator.language.split('-')[0];
	if (supportedLocales.includes(browserLang as SupportedLocale)) {
		return browserLang as SupportedLocale;
	}
	return 'fr';
}
